import PopOver from '../../lib/PopOver/PopOver';

import FilterListIcon from '@mui/icons-material/FilterList';
import React from 'react';
import {useTranslation} from 'react-i18next';
import './Filter.css';

const Filter = (props) => {
  const {t} = useTranslation();
  const renderPopOverBody = (filterOptions, propertyName) => {
    return (
      <div className="popOverBody">
        {filterOptions?.map((option, index) => (
          <div
            data-testid={'filterOption' + index}
            key={'filterOption' + option + 'key'}
            className={`popOverItem ${
              props.selectedFilter === t(option) ? 'filterSelected' : ''
            }`}
            onClick={() => props.createFilterHandler(t(option), propertyName)}
          >
            {t(option)}
          </div>
        ))}
      </div>
    );
  };
  return (
    <PopOver
      popOverButton={<FilterListIcon data-testid="filter" />}
      popOverBody={renderPopOverBody(
        props.filterOptionList,
        props.propertyName
      )}
    />
  );
};
export default Filter;
